document.addEventListener('DOMContentLoaded', function() {
  const openButton = document.querySelectorAll('.drawer-size-guide__button');
  const drawer = document.getElementById('main-menu-drawer');

  if (!openButton || !drawer) {
    console.error('Drawer or open button not found.');
    return;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';

    // document.querySelector('.page-container').style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    // document.querySelector('.page-container').style.overflow = '';
  }

  openButton.forEach(button => {
    button.addEventListener('click', openDrawer);
  });

  const closeButtons = drawer.querySelectorAll('[data-close-drawer]');
  closeButtons.forEach(button => {
    button.addEventListener('click', closeDrawer);
  });
});
